import { createContext } from "react";

export const CastContext = createContext({ hd: true });
